import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import OutboundExpiryReportActions, {
  OutboundExpiryReportTypes
} from '../Stores/OutboundExpiryReport/Actions';

const getAppStore = state => state.app;

export function* outboundExpiryReportInitOutboundExpiry() {
  try {
    yield put(OutboundExpiryReportActions.outboundExpiryReportReportLoading(true));

    const app = yield select(getAppStore);
    const getData = {};

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `salesReport/initOutbExpiryAnalysis/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      yield put(
        OutboundExpiryReportActions.outboundExpiryReportInitOutboundExpirySuccess(result.data)
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(OutboundExpiryReportActions.outboundExpiryReportReportLoading(false));
  }
}

export function* outboundExpiryReportOutboundExpiry({ formikBag, criteria }) {
  try {
    formikBag.setSubmitting(true);
    yield put(OutboundExpiryReportActions.outboundExpiryReportReportLoading(true));

    const objCriteria = {};
    if ('start_date' in criteria) {
      objCriteria.start_date = criteria.start_date;
    }
    if ('end_date' in criteria) {
      objCriteria.end_date = criteria.end_date;
    }
    if ('division_ids_select2' in criteria) {
      const values = criteria.division_ids_select2;
      if (values !== null && values.length > 0) {
        objCriteria.division_ids = values.map(entry => {
          return entry.value;
        });
      }
    }
    if ('delivery_point_ids_select2' in criteria) {
      const values = criteria.delivery_point_ids_select2;
      if (values !== null && values.length > 0) {
        objCriteria.delivery_point_ids = values.map(entry => {
          return entry.value;
        });
      }
    }
    if ('debtor_ids_select2' in criteria) {
      const values = criteria.debtor_ids_select2;
      if (values !== null && values.length > 0) {
        objCriteria.debtor_ids = values.map(entry => {
          return entry.value;
        });
      }
    }
    if ('item_ids_select2' in criteria) {
      const values = criteria.item_ids_select2;
      if (values !== null && values.length > 0) {
        objCriteria.item_ids = values.map(entry => {
          return entry.value;
        });
      }
    }
    if ('item_group_01_ids_select2' in criteria) {
      const values = criteria.item_group_01_ids_select2;
      if (values !== null && values.length > 0) {
        objCriteria.item_group_01_ids = values.map(entry => {
          return entry.value;
        });
      }
    }
    if ('item_group_02_ids_select2' in criteria) {
      const values = criteria.item_group_02_ids_select2;
      if (values !== null && values.length > 0) {
        objCriteria.item_group_02_ids = values.map(entry => {
          return entry.value;
        });
      }
    }
    if ('item_group_03_ids_select2' in criteria) {
      const values = criteria.item_group_03_ids_select2;
      if (values !== null && values.length > 0) {
        objCriteria.item_group_03_ids = values.map(entry => {
          return entry.value;
        });
      }
    }

    let columns = [];
    if (criteria.columns.target.length > 0) {
      columns = criteria.columns.target.map(entry => {
        return entry.column;
      });
    }

    const app = yield select(getAppStore);
    const postData = {
      sorts: [],
      criteria: objCriteria,
      columns
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `salesReport/outbExpiryAnalysis/${app.curSiteFlowId}`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(
        OutboundExpiryReportActions.outboundExpiryReportOutboundExpirySuccess(
          criteria,
          result.data.data
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    formikBag.setSubmitting(false);
    yield put(OutboundExpiryReportActions.outboundExpiryReportReportLoading(false));
  }
}

export function* outboundExpiryReportFetchDivisionOptions({ search }) {
  try {
    yield put(OutboundExpiryReportActions.outboundExpiryReportFetchDivisionOptionLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      search,
      filters: []
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `division/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const options = result.data.data.map(d => ({
        value: d.id,
        label: `${d.code} ${d.name_01}`
      }));

      yield put(
        OutboundExpiryReportActions.outboundExpiryReportFetchDivisionOptionSuccess(options)
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(OutboundExpiryReportActions.outboundExpiryReportFetchDivisionOptionLoading(false));
  }
}

export function* outboundExpiryReportFetchDeliveryPointOptions({ search }) {
  try {
    yield put(
      OutboundExpiryReportActions.outboundExpiryReportFetchDeliveryPointOptionLoading(true)
    );

    const app = yield select(getAppStore);
    const postData = {
      search,
      filters: []
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `deliveryPoint/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const options = result.data.data.map(d => ({
        value: d.id,
        label: `${d.code} ${d.company_name_01}`
      }));

      yield put(
        OutboundExpiryReportActions.outboundExpiryReportFetchDeliveryPointOptionSuccess(options)
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(
      OutboundExpiryReportActions.outboundExpiryReportFetchDeliveryPointOptionLoading(false)
    );
  }
}

export function* outboundExpiryReportFetchDebtorOptions({ search }) {
  try {
    yield put(OutboundExpiryReportActions.outboundExpiryReportFetchDebtorOptionLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      debtorType: 1, // 0 = normal, 1 = principal
      search,
      filters: []
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `debtor/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const options = result.data.data.map(d => ({
        value: d.id,
        label: `${d.code} ${d.company_name_01} ${d.company_name_02}`
      }));

      yield put(OutboundExpiryReportActions.outboundExpiryReportFetchDebtorOptionSuccess(options));
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(OutboundExpiryReportActions.outboundExpiryReportFetchDebtorOptionLoading(false));
  }
}

export function* outboundExpiryReportFetchItemOptions({ search }) {
  try {
    yield put(OutboundExpiryReportActions.outboundExpiryReportFetchItemOptionLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      search,
      filters: []
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `item/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const options = result.data.data.map(d => ({
        value: d.id,
        label: `${d.code} ${d.desc_01}`
      }));

      yield put(OutboundExpiryReportActions.outboundExpiryReportFetchItemOptionSuccess(options));
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(OutboundExpiryReportActions.outboundExpiryReportFetchItemOptionLoading(false));
  }
}

export function* outboundExpiryReportFetchItemGroup01Options({ search }) {
  try {
    yield put(OutboundExpiryReportActions.outboundExpiryReportFetchItemGroup01OptionLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      search,
      filters: []
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `itemGroup01/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const options = result.data.data.map(d => ({
        value: d.id,
        label: `${d.code} ${d.desc_01}`
      }));

      yield put(
        OutboundExpiryReportActions.outboundExpiryReportFetchItemGroup01OptionSuccess(options)
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(OutboundExpiryReportActions.outboundExpiryReportFetchItemGroup01OptionLoading(false));
  }
}

export function* outboundExpiryReportFetchItemGroup02Options({ search }) {
  try {
    yield put(OutboundExpiryReportActions.outboundExpiryReportFetchItemGroup02OptionLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      search,
      filters: []
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `itemGroup02/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const options = result.data.data.map(d => ({
        value: d.id,
        label: `${d.code} ${d.desc_01}`
      }));

      yield put(
        OutboundExpiryReportActions.outboundExpiryReportFetchItemGroup02OptionSuccess(options)
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(OutboundExpiryReportActions.outboundExpiryReportFetchItemGroup02OptionLoading(false));
  }
}

export function* outboundExpiryReportFetchItemGroup03Options({ search }) {
  try {
    yield put(OutboundExpiryReportActions.outboundExpiryReportFetchItemGroup03OptionLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      search,
      filters: []
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `itemGroup03/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const options = result.data.data.map(d => ({
        value: d.id,
        label: `${d.code} ${d.desc_01}`
      }));

      yield put(
        OutboundExpiryReportActions.outboundExpiryReportFetchItemGroup03OptionSuccess(options)
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(OutboundExpiryReportActions.outboundExpiryReportFetchItemGroup03OptionLoading(false));
  }
}

export const saga = [
  takeLatest(
    OutboundExpiryReportTypes.OUTBOUND_EXPIRY_REPORT_INIT_OUTBOUND_EXPIRY,
    outboundExpiryReportInitOutboundExpiry
  ),
  takeLatest(
    OutboundExpiryReportTypes.OUTBOUND_EXPIRY_REPORT_OUTBOUND_EXPIRY,
    outboundExpiryReportOutboundExpiry
  ),

  takeLatest(
    OutboundExpiryReportTypes.OUTBOUND_EXPIRY_REPORT_FETCH_DIVISION_OPTIONS,
    outboundExpiryReportFetchDivisionOptions
  ),
  takeLatest(
    OutboundExpiryReportTypes.OUTBOUND_EXPIRY_REPORT_FETCH_DELIVERY_POINT_OPTIONS,
    outboundExpiryReportFetchDeliveryPointOptions
  ),

  takeLatest(
    OutboundExpiryReportTypes.OUTBOUND_EXPIRY_REPORT_FETCH_DEBTOR_OPTIONS,
    outboundExpiryReportFetchDebtorOptions
  ),

  takeLatest(
    OutboundExpiryReportTypes.OUTBOUND_EXPIRY_REPORT_FETCH_ITEM_OPTIONS,
    outboundExpiryReportFetchItemOptions
  ),
  takeLatest(
    OutboundExpiryReportTypes.OUTBOUND_EXPIRY_REPORT_FETCH_ITEM_GROUP01_OPTIONS,
    outboundExpiryReportFetchItemGroup01Options
  ),
  takeLatest(
    OutboundExpiryReportTypes.OUTBOUND_EXPIRY_REPORT_FETCH_ITEM_GROUP02_OPTIONS,
    outboundExpiryReportFetchItemGroup02Options
  ),
  takeLatest(
    OutboundExpiryReportTypes.OUTBOUND_EXPIRY_REPORT_FETCH_ITEM_GROUP03_OPTIONS,
    outboundExpiryReportFetchItemGroup03Options
  )
];
